import axios from 'axios';
import { API_RESULT } from '../../modules/api';
import { newInParam } from '../../helpers/helpers';

const setSessionDepartment = department => (dispatch, getState) => {
  axios.post(`/api/set_department/${department}`).then(response => {
    const { countryCode } = getState();
    dispatch({ payload: response.data, type: API_RESULT });
    window.location.href = `/${countryCode}/${department.toLowerCase()}?${newInParam}`;
  });
};

export default setSessionDepartment;
